// Variables map. eg: { "id": 1, "name": "Jon Doe" }
function queryVariablesMap(variables, fields) {
  const variablesMapped = {};
  const update = (vars) => {
    if (vars) {
      Object.keys(vars).map((key) => {
        variablesMapped[key] =
          typeof vars[key] === 'object' ? vars[key].value : vars[key];
      });
    }
  };

  update(variables);
  if (fields && typeof fields === 'object') {
    update(getNestedVariables(fields));
  }
  return variablesMapped;
}

function getNestedVariables(fields) {
  let variables = {};
  fields?.forEach((field) => {
    if (isNestedField(field)) {
      variables = {
        ...field.variables,
        ...variables,
        ...(field.fields && getNestedVariables(field.fields))
      };
    }
  });
  return variables;
}

function queryDataType(variable) {
  let type = 'String';

  const value = typeof variable === 'object' ? variable.value : variable;

  if (variable?.type != null) {
    type = variable.type;
  } else {
    // TODO: Should handle the undefined value (either in array value or single value)
    const candidateValue = Array.isArray(value) ? value[0] : value;
    switch (typeof candidateValue) {
      case 'object':
        type = 'Object';
        break;

      case 'boolean':
        type = 'Boolean';
        break;

      case 'number':
        type = candidateValue % 1 === 0 ? 'Int' : 'Float';
        break;
    }
  }

  // set object based variable properties
  if (typeof variable === 'object') {
    if (variable.list === true) {
      type = `[${type}]`;
    } else if (Array.isArray(variable.list)) {
      type = `[${type}${variable.list[0] ? '!' : ''}]`;
    }

    if (variable.required) {
      type += '!';
    }
  }

  return type;
}

function queryDataNameAndArgumentMap(variables) {
  return variables && Object.keys(variables).length
    ? `(${Object.entries(variables).reduce((dataString, [key, value], i) => {
        return `${dataString}${i !== 0 ? ', ' : ''}${
          value && value.name ? value.name : key
        }: $${key}`;
      }, '')})`
    : '';
}

function queryFieldsMap(fields) {
  return fields
    ? fields
        .map((field) => {
          if (isNestedField(field)) {
            return queryNestedFieldMap(field);
          } else if (typeof field === 'object') {
            const values = Object.values(field)[0];
            return `${Object.keys(field)[0]} ${
              values.length > 0 ? '{ ' + queryFieldsMap(values) + ' }' : ''
            }`;
          } else {
            return `${field}`;
          }
        })
        .join(', ')
    : '';
}

function queryNestedFieldMap(field) {
  return `${field.operation} ${queryDataNameAndArgumentMap(field.variables)} ${
    field.fields.length > 0 ? '{ ' + queryFieldsMap(field.fields) + ' }' : ''
  }`;
}

function isNestedField(object) {
  return (
    typeof object === 'object' &&
    object.hasOwnProperty('operation') &&
    object.hasOwnProperty('variables') &&
    object.hasOwnProperty('fields')
  );
}

export {
  queryDataType,
  getNestedVariables,
  queryVariablesMap,
  queryDataNameAndArgumentMap,
  queryFieldsMap
};
